import {Button, Card, Popconfirm, Table} from 'antd';
import {useStore} from 'effector-react';
import {
    $govPlanPreviewImport,
    $selectedGmk,
    govApprovePlanImportEv
} from '../../../models/uploadModel/index.js';
import {useEvent} from 'effector-react/compat';
import {previewColumns} from './columns.js';

const ConfirmLocal = () => {
    const data = useStore($govPlanPreviewImport)
    const selectedGmk = useStore($selectedGmk)

    const confirmPlanImport = useEvent(govApprovePlanImportEv)

    return <Card
        title={`Предпросмотр импортного плана - ${selectedGmk?.organization ?? '-'}`}
        extra={
            <Popconfirm title={'Вы уверены? Данное действие необратимо.'}
                        onConfirm={() => confirmPlanImport()}
                        placement={'left'}
                        okText={'Да'}
                        cancelText={'Нет'}
                        okButtonProps={{className: 'btn-primary'}}
                        cancelButtonProps={{className: 'btn-secondary'}}
            >
                <Button type={'primary'} className={'btn-primary'}>
                    Подтвердить план
                </Button>
            </Popconfirm>
        }
    >
        <Table
            dataSource={data}
            bordered={true}
            columns={previewColumns}
            pagination={{
                position: ['bottomCenter'],
                pageSizeOptions: [10, 20, 50, 100],
                defaultPageSize: 20
            }}
        />
    </Card>
}

export default ConfirmLocal